var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.content),function(item,index){return _c('div',{key:index,style:(index === _vm.lineIndex ? _vm.styleArr : [_vm.styleArr[0]])},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }